import { EnumBase } from 'hay-core-react';
class ModalidadePagamentoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.modalidade.modalidadepagamento.pix',
                'main.modalidade.modalidadepagamento.cartaocredito',
                'main.modalidade.modalidadepagamento.boleto',
                'main.modalidade.modalidadepagamento.isento',
            ],
            'main.modalidade.modalidadepagamento.pix'
        );
    }
}

const instance = new ModalidadePagamentoEnum();
export default instance;
